<div class="row gx-5 m-0 p-0">
    <div class="col-12 col-lg-6 my-lg-4 px-0 pe-lg-2 rounded">
        <img class="w-100" src="../../../assets/img/garantia.png" alt="">
    </div>
    <div class="col-12 col-lg-6 my-4 px-0 ps-lg-3">
        <div class="h-100 px-4 px-md-5 flex aling-items-center white rounded shadow-sm">
            <div class="row py-4 h-100 m-0 p-0">
                <div class="col-12 m-0 p-0 d-flex flex-column justify-content-center">
                    <p class="mb-lg-2 mb-xl-4">
                        <b> {{ 'ITEM_FAILURE.LABEL1' | translate }} </b> {{ 'ITEM_FAILURE.LABEL2' | translate }} 
                    </p>
                    <p class="mb-lg-2 mb-xl-4">
                        <b> {{ 'ITEM_FAILURE.LABEL3' | translate }} </b> {{ 'ITEM_FAILURE.LABEL4' | translate }} <b> {{ 'ITEM_FAILURE.LABEL5' | translate }} </b>  {{ 'ITEM_FAILURE.LABEL6' | translate }} 
                    </p>
                    <p class="mb-lg-2 mb-xl-4">
                        {{ 'ITEM_FAILURE.LABEL7' | translate }} <b> {{ 'ITEM_FAILURE.LABEL8' | translate }} </b> {{ 'ITEM_FAILURE.LABEL9' | translate }} <b> {{ 'ITEM_FAILURE.LABEL10' | translate }} </b> {{ 'ITEM_FAILURE.LABEL11' | translate }} <b><u> {{ 'ITEM_FAILURE.LABEL12' | translate }} </u> {{ 'ITEM_FAILURE.LABEL13' | translate }} </b>
                    </p>
                    <div *ngIf="!isMobile" class="d-flex mt-lg-1 mt-xl-3 justify-content-center">
                        <button class="btn-w btn-h primary-bg-color" mat-flat-button color="accent"> {{ 'ITEM_FAILURE.LABEL5' | translate }} </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isMobile" class="mt-4 w-100 px-0">
        <button class="primary-bg-color w-100 btn-h" mat-flat-button color="accent"> {{ 'ITEM_FAILURE.LABEL5' | translate }} </button>
    </div>
</div>